// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "field-3H3Wl";
var _5 = "field_swapRight-BQB1m";
var _6 = "field_swapLeft-1jxjn";
var _7 = "documentCount-1S2IF";
var _8 = "documentCount_single-YLeZc";
var _9 = "dropdown-KsNNU";
var _a = "swap-dcAI9";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "field", _5 as "field_swapRight", _6 as "field_swapLeft", _7 as "documentCount", _8 as "documentCount_single", _9 as "dropdown", _a as "swap" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "field": _4, "field_swapRight": _5, "field_swapLeft": _6, "documentCount": _7, "documentCount_single": _8, "dropdown": _9, "swap": _a }
